import React from 'react';
import { Box, Header, Text } from '@generationtux/component-library';
import { getProductByCatalogNumber } from '../../utils/utils';

const TitleBar = ({ selectedCatalogNumbers, props }) => {
  return (
    <Box>
      <Box display="flex" alignItems="center">
        <Header type={2} size={3} as="span">
          Look 1
        </Header>
        <Box mx={2}>-</Box>
        <Text display="inline" as="span" size="sm" textColor="grayDarker">
          $
          {selectedCatalogNumbers.reduce((acc, val, index) => {
            if (!val.activeItem) {
              return acc;
            }
            const product = getProductByCatalogNumber(val.activeItem);
            if (product.type !== 'Pants') {
              acc = acc + product.costToCustomer;
            }
            return acc;
          }, 0)}
        </Text>
      </Box>
    </Box>
  );
};

export default TitleBar;
